<template>
  <div class="video-block section-padding">
    <div class="row">
      <div class="col-md-12">
        <div class="main-title">
          <VideoSort />
          <h6>My Videos</h6>
        </div>
      </div>
      <VideoBig />
      <VideoBig />
      <VideoBig />
      <VideoBig />
    </div>
  </div>
</template>

<script>
export default {
  components: {
    VideoSort: () => import('@/components/video/VideoSort'),
    VideoBig: () => import('@/components/video/VideoBig'),
  },
};
</script>
